import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38c07fdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order" }
const _hoisted_2 = { class: "order-title flex-bwn" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OEM", -1))
const _hoisted_4 = { class: "times" }
const _hoisted_5 = { class: "num" }
const _hoisted_6 = { class: "order-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "order-item-name" }

import { ref, watch, watchEffect, Ref, reactive, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { useLevel, useRtfix, useUser } from '@/store'
import { ElMessageBox } from 'element-plus'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const oemTypeList = reactive([
  {
    name: t('新增寻源任务'),
    icon: 'https://static-s.theckb.com/BusinessMarket/member/client_oem_icon1.png',
    num: 0,
    route: '/oem/order/addFindSource'
  },
  {
    name: t('寻源单列表'),
    icon: 'https://static-s.theckb.com/BusinessMarket/member/client_oem_icon2.png',
    num: 0,
    route: '/oem/order/oemSourceList'
  },
  {
    name: t('OEM商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/member/client_oem_icon3.png',
    num: 0,
    route: '/oem/goods/list'
  }
])

const level = useLevel()

const warningImg = require('@/assets/image/icon/member/icon_hint@2x.png')
const confirmMember = () => {
  ElMessageBox.confirm(
    `<img src='${warningImg}' style='position:absolute;top:-38px;height:20px;width:20px'/><p style='white-space:pre-wrap'>
      ${t('标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务')}
    <p>`,
    t('注意3'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('会员登录'),
      cancelButtonText: t('关闭'),
      distinguishCancelAndClose: true,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      customClass: 'sidebarMemberConfirm'
    }
  )
    .then(() => {
      const routerUrl: any = router.resolve(useRtfix('VipLevel'))
      window.open(routerUrl.href, '_black')
    })
}

const jump = (v: typeof oemTypeList[number]) => {
  if (level <= 1) {
    confirmMember()
  } else {
    location.href = v.route
  }
}

const count = ref(0)

onMounted(async () => {
  const { data: { currentAvailableQuantity } = {} } = await request.customer.free.countSelectFreeCountByType({ type: 2 })
  count.value = currentAvailableQuantity ?? 0
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(t)('免费寻源')) + " ", 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(count.value), 1),
        _createTextVNode(" " + _toDisplayString(_unref(t)('次')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(oemTypeList), (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "order-item"
        }, [
          _createElementVNode("div", {
            class: "order-item flex-col-ter",
            onClick: ($event: any) => (jump(item))
          }, [
            _createElementVNode("img", {
              class: "order-item-icon",
              src: item.icon
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1)
          ], 8, _hoisted_7)
        ]))
      }), 128))
    ])
  ]))
}
}

})